
const baseImgUrl = process.env.NODE_ENV === 'production' ? "https://gf.cleair-cn.com" : "https://https://gf.cleair-cn.com"

let baseApiUrl = process.env.NODE_ENV == 'production' ? "https://apicdn.cqezdj.com" : "https://csback.cqezdj.com"

// 线上前端网址
let onlineUrl = process.env.NODE_ENV == 'production' ? "https://jshtml.cqezdj.com" : "https://csjsnose.cqezdj.com"

// #ifdef H5-UAT
baseApiUrl = 'https://csback.cqezdj.com'
onlineUrl = 'https://csjsnose.cqezdj.com'
// #endif

// #ifdef H5-SHOW
baseApiUrl = 'https://ceshi.cqezdj.com'
onlineUrl = 'https://show.master.cgezdj.com'
// #endif

export {
	baseImgUrl,
	onlineUrl,
	baseApiUrl
}

// 客服电话
export const phoneNumber = "400-880-2575"
// if (process.env.NODE_ENV === 'development') {
//     // TODO
// }
// // uEnvProd
// if (process.env.NODE_ENV === 'production') {
//     // TODO
// }
export const callPhone = () => {
    uni.makePhoneCall({
        phoneNumber
    });
}
